import { Router } from '@angular/router';
import { fuseAnimations } from './../../../../@fuse/animations/index';
import { NotificationService } from './../../../main/pages/accompaniments/notification.service';
import { ChangeDetectorRef, Component, ViewChild, ViewEncapsulation } from '@angular/core';
import { ToolbarComponent } from '../toolbar/toolbar.component';
import { forkJoin } from 'rxjs';
import { Notification } from 'app/entities/notification';
import { FuseSidebarService } from '@fuse/components/sidebar/sidebar.service';

@Component({
    selector: 'quick-panel',
    templateUrl: './quick-panel.component.html',
    styleUrls: ['./quick-panel.component.scss'],
    encapsulation: ViewEncapsulation.None,
    animations: fuseAnimations
})
export class QuickPanelComponent {
    notifications: Notification[] = [];

    @ViewChild(ToolbarComponent) toolbarComponent: ToolbarComponent;

    constructor(
        private _notificationService: NotificationService,
        private _fuseSidebarService: FuseSidebarService,
        private _router: Router,
        private cd: ChangeDetectorRef,
    ) {
        this._notificationService.findAll({}).subscribe(res => {
            this.notifications = res.data
        })

        this._router.routeReuseStrategy.shouldReuseRoute = () => false;
        this._router.onSameUrlNavigation = 'reload';
    }

    ngOnInit() {
        this.load();

        this._notificationService.reload$.subscribe(() => {
            this.load();
        });
    }

    load() {
        this._notificationService.findAll({}).subscribe(res => {
            this.notifications = res.data
        });
    }

    async navigateToNotifiable(notification: any) {
        let notifiableType: string = notification.notifiableType;
        let route: string;
        let queryParams: { [key: string]: any };

        const className = notifiableType.split('\\').pop()?.toLowerCase() || '';

        switch (className) {
            case 'call':
                route = `accompaniments/${notification.notifiable.accompaniment_id}`;
                queryParams = { selectedIndex: 2 };
                break;
            case 'analisecritica':
                route = `analises-criticas/${notification.notifiable.id}`;
                queryParams = { selectedIndex: 2 };
                break;
            case 'criticalanalysislink':
                route = `planos-producao/${notification.notifiable.cliente_id}`;
                queryParams = { selectedIndex: 1 };
                break;
            case 'cliente':
                route = `planos-producao/${notification.notifiable.id}`;
                queryParams = { selectedIndex: 1 };
                break;
            case 'contract':
                route = `clientes/${notification.notifiable.cliente_id}`;
                queryParams = { selectedIndex: 1 };
                break;
            default:
                console.error(`Unknown notifiable type: ${notifiableType}`);
                return;
        }

        this._fuseSidebarService.getSidebar('quickPanel').close();
        this._router.navigate([route], {
            replaceUrl: true,
            queryParams: queryParams
        });
    }

    markAsRead(notification: any, event: MouseEvent): void {
        event.stopPropagation();

        if (notification.read_at) return;

        this._notificationService.markAsRead(notification.id).subscribe({
            next: () => {
                const index = this.notifications.indexOf(notification);
                if (index !== -1) {
                    this.notifications.splice(index, 1);
                }
                this.cd.detectChanges();
                this.ngOnInit();
                this._notificationService.notifyNotificationCountUpdated();
            },
            error: err => console.error('Erro ao marcar como lida', err)
        });
    }

    markAllAsRead(): void {
        this._notificationService.markAllAsRead().subscribe({
            next: () => {
                this.notifications = [];
                this.cd.detectChanges();
                this.ngOnInit();
                this._notificationService.notifyNotificationCountUpdated();
            },
            error: err => console.error('Erro ao marcar como lida', err)
        })
    }

}
